module.exports = __webpack_public_path__ + "media/2.45871788.mp3";